module.exports = __webpack_public_path__ + "img/portada-web.c562432b.jpg";